

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from './ReducingYourRisk.css';
import withStyles from '../../decorators/withStyles';
import {simplePlaceName} from "../../utils/utils";
import {sameLocationNewHash} from "../../utils/utils";
import AnchoredComponent from "../AnchoredComponent";


class ReducingYourRisk extends AnchoredComponent {

  static propTypes = {
    placeType: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
    placeName: PropTypes.string.isRequired,
    placeContainer: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {expanded: false}
  }

  componentWillReceiveProps(props) {
    if (props.placeID !== this.props.placeID || props.placeType !== this.props.placeType) {
      this.setState({expanded: false})
    }
  }

  render() {
    const { placeType, placeID, placeName, placeContainer, data }  = this.props;

    const stateLinks = this.state.expanded ? data.state : data.state.slice(0, 7);
    return (
      <section className="ReducingYourRisk">
        <div className="header">
          <a className="anchor" id="reducing-your-risk"/>
          <Link className="hash-link" to={sameLocationNewHash("#reducing-your-risk")}>
            <h1>Reducing Your Risk <span className="anchor-hash"><emph>#</emph></span></h1>
          </Link>
          <p>Even with strong action to curb heat-trapping pollution, some future sea level rise is inevitable.</p>
        </div>
        <div>
          <h2>Preparing yourself and your community</h2>
          <ul>
            <li>
            <a href="http://sealevel.climatecentral.org/flood-preparation/" target="_blank">
              Actions you can take yourself
            </a> can reduce flood risk and sea level impacts.
              </li>
            <li>
              Surging Seas can help your community participate in
              FEMA's <a href="http://www.floodsmart.gov/floodsmart/pages/crs/community_rating_system.jsp" target="_blank">Community Rating System</a> (CRS). <a href="http://sealevel.climatecentral.org/crs/" target="_blank">Get our guide</a>.
            </li>
            <li>
              Climate Central's <a href="http://sealevel.climatecentral.org/maps/custom-analysis/" target="_blank">tailored mapping, projections and analysis</a> can
              help you meet your more specific needs.
            </li>
          </ul>
        </div>
        {placeType === "state" && data.state ?
          <div>
            <h2>Select resources for {simplePlaceName(placeName)}</h2>
            <ul>{stateLinks.map(datum => {
              return (<li key={`/${datum.url}`}>
                <a href={datum.url} target="_blank">
                  {datum.source}
                </a>
              </li>)}
            )}
            </ul>
          </div>
        :
          <div>
            <h2>Select resources for {placeContainer.name}</h2>
            <ul>{stateLinks.map(datum => {
              return (<li key={`/${datum.url}`}>
                <a href={datum.url} target="_blank">
                  {datum.source}
                </a>
              </li>)}
            )}
            </ul>
          </div>
        }
        {!this.state.expanded ?
          <p className="expand-links" onClick={() => this.setState({expanded: true})}>+ &nbsp;Show more</p>
          :
          <p className="expand-links" onClick={() => this.setState({expanded: false})}>&ndash; &nbsp;Show less</p>
        }
        {data.national ?
          <div>
            <h2>Select national resources</h2>
            <ul>{data.national.map(datum => {
              return (<li key={`/${datum.url}`}>
                <a href={datum.url} target="_blank">
                  {datum.source}
                </a>
              </li>)}
            )}
            </ul>
          </div>
        : null}
        <br/>
        <p>Suggestions? Email
          us: <a href="mailto:sealevel@climatecentral.org">sealevel@climatecentral.org</a>
        </p>
      </section>
    );
  };
}

export default withStyles(styles)(ReducingYourRisk);
